import React, { Dispatch, SetStateAction } from 'react'
import { Link } from 'react-router-dom';
import { SearchTable } from '../../../../Components/SearchTable';
import { ListDefault } from '../../../../Components/ListDefault';
import { Edit, ToggleLeft } from 'lucide-react';
import { Input } from '../../../../Components/Form/Input';

interface Props {
    pages: any,
    setSwitchPageListEmployee: any,
    metaTo: any,
    metaTotal: any,
    employees: any,
    setSelected: any,
    setSwitchScreen: any,
    setTypeProfile: any,
    onEditEmployee: any,
    inputSearchView: string,
    setInputSearchView: Dispatch<SetStateAction<string>>
}

const ListDirector = ({
    employees,
    onEditEmployee,
    setSelected,
    setSwitchScreen,
    setTypeProfile,
    inputSearchView,
    setInputSearchView
}: Props) => {
    return (
        <ListDefault
            onBack={() => {
                window.history.back();
            }}
            pages={[]}
            changeGet={(v: any) => { }}
            to={"1"}
            total={""}
        >
            <thead>
                <tr>
                    <td colSpan={7}>
                        <Input
                            flex="fx30"
                            type="search"
                            placeHolderTeacher="Pesquise por um diretor"
                            color="#039bc9"
                            value={inputSearchView}
                            onChange={setInputSearchView}
                        />
                    </td>
                </tr>
                <tr>
                    <td className="wd30">Nome</td>
                    <td className="wd15">Perfil/Função</td>
                    <td className="wd20">Email</td>
                    <td className="wd25">Unidade(s) de Ensino</td>
                    <td className="wd10">Ação</td>
                </tr>
            </thead>
            <tbody>
                {employees
                    ?.filter(
                        (option: any) =>
                            option.user.roles[0].slug === "director-employee"
                    )
                    .map((option: any) => {
                        return (
                            <tr>
                                <td>
                                    <Link
                                        to=""
                                        onClick={() => {
                                            setSelected(option);
                                            setSwitchScreen(2);
                                            setTypeProfile(4);
                                        }}
                                    >
                                        {option?.user.name}
                                    </Link>
                                </td>
                                <td>
                                    {option.user.roles[0]
                                        ? option.user.roles[0].name
                                        : "Não definido"}
                                </td>
                                <td>{option.user.email}</td>
                                <td>
                                    {option.educationInstitution
                                        ? option.educationInstitution.name
                                        : "Não definido"}
                                </td>
                                <td>
                                    <button
                                        className="hvr-grow"
                                        onClick={() => onEditEmployee(option)}
                                    >
                                        <Edit />
                                    </button>
                                    <button
                                        className="hvr-grow"
                                        style={{ color: "green", marginLeft: "10px" }}
                                    >
                                        <ToggleLeft />
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
            </tbody>
        </ListDefault>
    )
}

export default ListDirector
